import React from 'react';
import DiscordContainer from './DiscordContainer';
const DiscordView = () => {
  return <DiscordContainer />;
};

export default DiscordView;
